// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__13MvX","load1":"Spinner_load1__3RhOC"};